import React from 'react'
import { CButton, CTooltip } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilCloudDownload } from '@coreui/icons'

/**
 * [RGM] 2026-10-01 (pedido Rafael): botón de DESCARGA de cada gráfica —
 * replica el estilo del ejemplo oficial de CoreUI (CButton primary con el
 * icono cilCloudDownload / nube ↓). La ubicación la define el consumidor vía
 * className: en el chart de Operación va float-end junto a Día/Mes/Año (como
 * CoreUI); en las tarjetas con header va absoluto (esquina superior derecha —
 * no ocupa espacio de flujo, así no mueve ni agranda la tarjeta).
 * Descarga el canvas del chart como PNG (chart.js dibuja en <canvas>).
 */
const BotonCapturaChart: React.FC<{
  contenedorRef: React.RefObject<HTMLElement | null>
  nombre: string
  className?: string
}> = ({ contenedorRef, nombre, className }) => {
  const capturar = () => {
    const canvas = contenedorRef.current?.querySelector('canvas')
    if (!canvas) return
    const a = document.createElement('a')
    a.href = (canvas as HTMLCanvasElement).toDataURL('image/png')
    a.download = `${nombre}.png`
    a.click()
  }

  return (
    <CTooltip content="Descargar imagen" placement="top">
      <CButton
        color="primary"
        size="sm"
        onClick={capturar}
        aria-label="Descargar imagen de la gráfica"
        className={className}
      >
        <CIcon icon={cilCloudDownload} />
      </CButton>
    </CTooltip>
  )
}

export default BotonCapturaChart
